import React, { useState, useEffect } from 'react';
import '../commonCss/Navbar.css';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// import "react-lazy-load-image-component/src/effects/blur.css";

import { setLanguage, useTranslation } from 'react-multi-lang';

import translateText from '../translationService.js';
import apple from '../icons/App Store.svg';
import android from '../icons/Play Store.svg';
import newlogo from '../images/BBT_WHITE_2.png.png';

import { useLocation } from 'react-router-dom'; // Import useLocation

const Navbar = () => {

    const t = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState('en');
    const [translations, setTranslations] = useState({});
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation(); // Get current route location

    // Check if current route is terms-and-conditions
    const isTermsRoute = location.pathname === '/terms-and-conditions';
    const handleLanguageChange = async (lang) => {
        setCurrentLanguage(lang);
        setLanguage(lang);

        // Automatically fetch translations for your content
        const textToTranslate = {
            global: 'GLOBAL',
            english: 'English',
            french: 'French',
            arabic: 'Arabic',
            content: 'Welcome to our website',
        };

        const translatedTexts = {};
        for (const [key, text] of Object.entries(textToTranslate)) {
            translatedTexts[key] = await translateText(text, lang);
        }

        setTranslations(translatedTexts);
    };

    useEffect(() => {
        setLanguage(currentLanguage); // Initialize with the default language
    }, []);




    const [isVisible, setIsVisible] = useState(false);

    // Scroll event listener
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    // const [isInnerDropdownOpen, setIsInnerDropdownOpen] = useState(false);

    // const toggleInnerDropdown = (e) => {
    //     e.stopPropagation(); // Prevent closing the parent dropdown
    //     setIsInnerDropdownOpen(!isInnerDropdownOpen); // Toggle inner dropdown visibility
    // };


    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Generate class name based on conditions
    const getHeaderClassName = () => {
        if (isTermsRoute) {
            return 'header terms-route'; // Always apply terms-route class on terms page
        }
        return `header ${isScrolled ? 'scrolled' : ''}`;
    };

    return (
        <>
            <div className={getHeaderClassName()}>
                <nav className="navbar navbar-expand-lg navbar-light mb-0 pb-0 pt-md-2 pt-0">
                    <div className="container-fluid navbars">
                        <a className="navbar-brand navlogo ps-lg-4" href="/">
                            <LazyLoadImage
            effect="blur"
 src={newlogo} alt="" loading="lazy"/>
                            {/* <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/bbtlogo.png" alt="" /> */}
                        </a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false"
                            aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse " id="navbarNavDropdown">
                            <span className="close-menu d-lg-none d-block" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown">✖</span>
                            <div className="d-flex flex-column me-xxl-4">
                                <div className="list mt-2 align-self-sm-center align-self-md-start align-self-xxl-end">
                                    <ul className="navbar-nav custom-navbar  align-self-md-start align-self-xxl-end ms-2 ps-2 ms-md-0 align-items-lg-center">
                                        <li className="nav-item dropdown navItem fs-6 ">
                                            <a
                                                className="nav-link pe-2"
                                                href="/"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                activeClassName="active-link"
                                                exact
                                                id="dropdownbutton1"
                                            >
                                                DISCOVER BBT
                                            </a>
                                            <div
                                                className="drop-arrow"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >

                                            </div>
                                            <ul className="dropdown-menu header-drop-menu" aria-labelledby="dropdownbutton1">
                                                <a href="/our-story" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark d-block">Our Story</p>
                                                    </li>
                                                </a>
                                                <a href="/mission-vision" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">Vision & Mission</p>
                                                    </li>
                                                </a>
                                                <a href="/our-location" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">Our Locations</p>
                                                    </li>
                                                </a>
                                                <a href="/awards" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark d-block">Awards & Achievements</p>
                                                    </li>
                                                </a>

                                            </ul>
                                        </li>

                                        <li className="nav-item dropdown navItem fs-6 ">
                                            <a
                                                className="nav-link pe-1"
                                                href="/"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                activeClassName="active-link"
                                                id="dropdownbutton2"
                                            >
                                                WHAT WE DO?
                                            </a>
                                            <div
                                                className="drop-arrow"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >

                                            </div>
                                            <ul className="dropdown-menu header-drop-menu" aria-labelledby="dropdownbutton2">
                                                <a href="/corporate-travel" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark d-block">
                                                            Corporate Travel Management
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/consultation" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">
                                                            Consultations
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/meeting" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark d-block">
                                                            Meeting & Events
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/travel-arrangements" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">
                                                            Travel Arrangements
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/bliesure" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">
                                                            BLeisure
                                                        </p>
                                                    </li>
                                                </a>
                                            </ul>
                                        </li>

                                        <li className="nav-item dropdown navItem fs-6 ">
                                            <a className="nav-link pe-1" href="/" data-bs-toggle="dropdown" aria-expanded="false" activeClassName="active-link" id="dropdownbutton3">
                                                TRAVEL SOLUTIONS
                                            </a>
                                            <div
                                                className="drop-arrow"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >

                                            </div>
                                            <ul className="dropdown-menu header-drop-menu" aria-labelledby="dropdownbutton3">
                                                <a href="/tech-platform" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">
                                                            Our Tech Platforms
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/global-solution" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">
                                                            Global Solutions
                                                        </p>
                                                    </li>
                                                </a>
                                            </ul>
                                        </li>

                                        <li className="nav-item dropdown navItem fs-6 ">
                                            <a
                                                className="nav-link pe-1"
                                                href="/"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                activeClassName="active-link"
                                                id="dropdownbutton4"
                                            >
                                                RESOURCES
                                            </a>
                                            <div
                                                className="drop-arrow"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >

                                            </div>
                                            <ul className="dropdown-menu header-drop-menu" aria-labelledby="dropdownbutton4">
                                                <a href="business-travel" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark text-decoration-none d-block">
                                                            Business Travel
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/blog" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark text-decoration-none d-block">
                                                            Blogs
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/restrictions" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">
                                                            Restrictions & Guide
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/event-webinar" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark text-decoration-none d-block">
                                                            Events Webinars
                                                        </p>
                                                    </li>
                                                </a>
                                                <a href="/case-studies" className='text-decoration-none'>
                                                    <li className="dropdown-item header-drop-item">
                                                        <p className="text-dark  d-block">
                                                            Case Studies
                                                        </p>
                                                    </li>
                                                </a>
                                            </ul>
                                        </li>



                                        <li className="nav-item navItem fs-6 fw-bold ">

                                            <a
                                                className="nav-link pe-1"
                                                href="/contact"

                                            >
                                                CONTACT
                                            </a>
                                        </li>


                                        <li className="nav-item dropdown d-flex navItem fs-6  fw-bold ">
                                            <a href="/partners" id="dropdownbutton4"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false">
                                                <button
                                                    className={`border-0 join-btn rounded-pill ${isScrolled ? 'scrolled' : ''}`}

                                                >
                                                    TRAVEL TECH
                                                </button></a>

                                            <ul className="dropdown-menu" aria-labelledby="dropdownbutton4">

                                                <li className="dropdown-item dropdown-submenu d-flex gap-3">
                                                    <button
                                                        className="btn dropdown-toggle pe-0"

                                                    >
                                                        Traveller App
                                                    </button>
                                                    <a href="https://play.google.com/store/apps/details?id=com.blueberrytraveler.ap"><LazyLoadImage
            effect="blur"
 src={android} alt="" className='store-img' loading="lazy" /></a>
                                                    <a href="https://apps.apple.com/us/app/blueberry-traveller/id6670241491"> <LazyLoadImage
            effect="blur"
 src={apple} alt="" className='store-img' loading="lazy" /></a>
                                                </li>

                                                <li className="dropdown-item dropdown-submenu d-flex gap-3">
                                                <a href="https://bbtportal.blueberry-travel.com/login" target="_blank" rel="noopener noreferrer">
                                                    <button className="btn">
                                                        BBT Portal
                                                    </button>
                                                </a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item dropdown  d-flex navItem fs-6  fw-bold carouselCaption">
                                            <a href="/partners">
                                                <button
                                                    className="btn gradient-join rounded-pill "

                                                >
                                                    JOIN US
                                                </button></a>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>

                    </div>
                </nav>
            </div>



        </>
    )


}

export default Navbar

